import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getInvoicesRequest } from "./actions";
import Loading from "../utils/loading/Loading";
import styles from "./UserInvoices.scss";
import Retry from "../utils/retry/Retry";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
} from "material-ui";
import { withStyles } from "material-ui/styles";
import withWidth, { isWidthUp, isWidthDown } from "material-ui/utils/withWidth";

const CustomTableCell = withStyles((theme) => ({
  head: {
    fontWeight: "bolder",
    // backgroundColor: theme.palette.primary.main,
    // color: theme.palette.common.white,
  },
}))(TableCell);

class UserInvoices extends React.Component {
  static propTypes = {
    admin: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      user: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
      }),
      subcription: PropTypes.shape({
        accountStatus: PropTypes.shape({
          isTrialExpired: PropTypes.bool,
          isCardAdded: PropTypes.bool,
          isSubscriptionExpired: PropTypes.bool,
          remaningTrialDays: PropTypes.number,
          stripeCurrentPeriodEnd: PropTypes.string,
        }),
      }),
    }).isRequired,
    login: PropTypes.shape({
      authData: PropTypes.shape({
        id: PropTypes.string.isRequired,
        userId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    getInvoicesRequest: PropTypes.func.isRequired,
    invoices: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.string,
      invoices: PropTypes.object,
    }),
  };

  state = {
    page: 0,
    rowsPerPage: 5,
  };

  componentWillMount() {
    this.handleResize();
  }
  componentDidMount() {
    this.getUserInvoices();
    window.addEventListener("resize", this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }
  handleResize = (e) => {
    const tableHeaderFooterHeight = 56;
    const tableCellHeight = 48;
    const paddingTop = 100;
    const bottomBarElem = this.props.getBottomBarElem();
    //const bottomBarHeight = elem.current.childNodes[0].clientHeight;
    const bottomBarHeight = bottomBarElem.current.clientHeight;
    const windowHeight = window.innerHeight;
    let rowsPerPage = Math.floor(
      (windowHeight -
        paddingTop -
        bottomBarHeight -
        2 * tableHeaderFooterHeight) /
        tableCellHeight
    );
    if (rowsPerPage <= 0) rowsPerPage = 1;
    console.log("rowsPerPage", rowsPerPage);
    this.setState({ rowsPerPage: rowsPerPage });
  };
  getUserInvoices = () => {
    const { id: accessToken, userId } = this.props.login.authData;
    this.props.getInvoicesRequest({ accessToken, userId, limit: 100 });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  timestampToDate(timeStamp) {
    var options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone: "UTC",
    };
    var date = new Date(timeStamp * 1000);
    return date.toLocaleDateString("fr-FR", options);
  }
  handleRetry = () => {
    this.getUserInvoices();
  };

  render() {
    const {
      invoices: { requesting, successful, error, invoices },
    } = this.props;
    const { rowsPerPage, page } = this.state;
    if (successful && invoices != null && invoices.invoices.data)
      var emptyRows =
        rowsPerPage -
        Math.min(
          rowsPerPage,
          invoices.invoices.data.length - page * rowsPerPage
        );

    return (
      <div ref="child" className={styles.centeredContainer}>
        {requesting && <Loading size={80} />}
        {error && <Retry message={error} onRetry={this.handleRetry} />}
        {successful && invoices.invoices.data === undefined && (
          <div className={styles.alert}>Vous n'avez aucune facture</div>
        )}
        {successful && invoices.invoices.data && (
          <div>
            <Paper className={styles.root}>
              <div className={styles.tableWrapper}>
                <Table className={styles.table}>
                  <TableHead>
                    <TableRow>
                      <CustomTableCell>Période</CustomTableCell>
                      {isWidthUp("sm", this.props.width) && (
                        <CustomTableCell>Emise le</CustomTableCell>
                      )}
                      {isWidthUp("sm", this.props.width) && (
                        <CustomTableCell numeric>Payé(€)</CustomTableCell>
                      )}
                      <CustomTableCell>Factures</CustomTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoices.invoices.data
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((invoice) => {
                        return (
                          <TableRow key={invoice.id}>
                            <CustomTableCell component="th" scope="row">
                              {this.timestampToDate(
                                invoice.lines.data[0].period.start
                              )}
                              -
                              {this.timestampToDate(
                                invoice.lines.data[0].period.end
                              )}
                            </CustomTableCell>
                            {isWidthUp("sm", this.props.width) && (
                              <CustomTableCell>
                                {this.timestampToDate(invoice.created)}
                              </CustomTableCell>
                            )}
                            {isWidthUp("sm", this.props.width) && (
                              <CustomTableCell numeric>
                                {invoice.amount_paid / 100}
                              </CustomTableCell>
                            )}
                            <CustomTableCell>
                              {" "}
                              <a
                                className={styles.link}
                                href={invoice.invoice_pdf}
                              >
                                Fichier PDF
                              </a>
                            </CustomTableCell>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 49 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </div>
              <TablePagination
                rowsPerPageOptions={[]}
                labelRowsPerPage="Lignes"
                labelDisplayedRows={({ from, to, count }) =>
                  `${from}-${to} de ${count}`
                }
                component="div"
                count={invoices.invoices.data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                  "aria-label": "Page Suivante",
                }}
                nextIconButtonProps={{
                  "aria-label": "Page Précédente",
                }}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  login: state.login,
  admin: state.admin,
  invoices: state.invoices,
});

export default withWidth()(
  connect(mapStateToProps, {
    getInvoicesRequest,
  })(UserInvoices)
);



// WEBPACK FOOTER //
// ./src/pages/userinvoices/UserInvoices.jsx